export default __webpack_public_path__ + "static/media/dummy-doc-img.518cef11.png";